module.exports = __webpack_public_path__ + "static/media/image-4.d96f29fa.png";